<template>
    <div class="search-form">
        <div class="row">
            <div class="col-lg-11 offset-lg-1">
                <h1 class="h3 search-form__title">Zoek een manege</h1>
                <div class="form-group" ref="schoolSearch">
                    <div class="form-control has-icon">
                        <button type="button" class="btn-icon" @click="handleClick(vmSearchQuery)">
                            <svgComponent
                                :width="24"
                                :height="24"
                                icon-name="icon-search"></svgComponent>
                        </button>
                        <input
                            type="text"
                            id="schoolSearch"
                            name="schoolSearch"
                            placeholder="Locatie, manegenaam, postcode"
                            v-model="vmSearchQuery"
                            @keyup.enter="handleClick(vmSearchQuery)"
                            autocomplete="off" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import svgComponent from '../../../components/svgComponent.vue';
import { useRidingschoolStore } from '../store/ridingschool.store';

// Composable
import { useSearchParamUpdate } from '../../../composables/useSearchParamUpdate';

// store
const ridingschoolStore = useRidingschoolStore();

const schoolSearch = ref<HTMLDivElement | null>(null);

const vmSearchQuery = ref<string>('');

function handleClick(query: string) {
    if (query) {
        ridingschoolStore.setSearchQuery(query);
        useSearchParamUpdate(ridingschoolStore, 'remove', 'page', '');
        useSearchParamUpdate(ridingschoolStore, 'update', 'query', query);
    }
}

onMounted(() => {
    if (ridingschoolStore.query) {
        vmSearchQuery.value = ridingschoolStore.query;
    }
});
</script>
